import { Palette } from "../../../../theme";

export interface BusyIndicatorProps {
  color?: string;
  size?: BusyIndicatorTypes;
}

export enum BusyIndicatorTypes {
  small = "25",
  medium = "50",
  large = "100",
}

export interface BusyIndicatorCssProps {
  fillColor?: string;
  width: BusyIndicatorTypes;
  height: string;
  viewBox: string;
  xmlns: string;
  theme?: Palette;
}
